<template>
  <div class="col">
    <div class="fm-questionnaire__top">
      <h1 class="sm">Test Your Knowledge</h1>
      <span class="h1">{{ question.prompt }}</span>
    </div>
    <div class="fm-questionnaire__middle">
      <p class="select-all">check all that apply</p>
      <div class="row">
        <div
          v-for="(option, index) in question.options"
          :key="index"
          class="col-12 col-md-6 fm-answers"
        >
          <label class="answer ">
            <input
              :id="`select-${index}`"
              v-model="selections"
              type="checkbox"
              name="selectAny"
              :value="index"
            >
            <span
              :for="`select-${index}`"
              class="label"
            >{{ option }}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="fm-questionnaire__bottom">
      <button
        class="btn button btn-medium"
        :class="{submitted: isSubmitted}"
        @click="
          isSubmitted = true;
          validateAnswer(question.correctAnswer);
        "
      >submit</button>
      <div
        v-if="isSubmitted"
        class="answer__submitted"
      >
        <div
          v-if="proceed === true"
        >
          <span class="answer__valid">
            <i
              class="fas fa-check-circle"
              aria-hidden="true"
            />
            {{ question.bottomHeaderTrue }}
          </span>
        </div>
        <div
          v-if="proceed !== true"
        >
          <span
            class="answer__invalid"
          >
            <i
              class="fas fa-times-circle"
              aria-hidden="true"
            />
            {{ question.bottomHeaderFalse }}
          </span>
        </div>
        <p class="answer__bottom">{{ question.bottomText }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MultipleChoiceQuestion',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    question: Object,
  },
  data() {
    return {
      selections: [],
      proceed: false,
      isSubmitted: false,
    };
  },
  methods: {
    validateAnswer(correctAnswer) {
      // 'selections' in this case are the indices of the items in the array that
      // creates the radio buttons.
      // correctAnswer are the correct answer indices.
      const equals = (a, b) =>
        a.length === b.length && a.every((val, i) => val === b[i]);
      this.proceed = equals(correctAnswer, this.selections.sort());
      this.$emit('proceed', this.isSubmitted);
    },
  },
};
</script>

<style>
</style>
